import React, {useEffect, useState} from 'react'
import {Elements,} from '@stripe/react-stripe-js'
import {useDispatch, useSelector} from "react-redux"
import {loadStripe, StripeElementsOptions} from "@stripe/stripe-js"
import {EnrollmentPaymentFormComponent} from "./enrollment-payment-form.component"
import {useNavigate, useSearchParams} from "react-router-dom"
import configData from '../../config/config.json'
import {RootState} from "../../common/store";
import {pageLoadingSActions} from "../../common/store/page-loading.state";
import {createIntent} from "../../service/stripe.service";
import {notificationActions} from "../../common/store/notification.state";
import {pipe} from "fp-ts/function"
import {getEnrollmentsCost} from "../../service/enrollment.service";
import {sequenceS} from "fp-ts/Apply";
import * as OBS from "fp-ts-rxjs/Observable";

export const EnrollmentPaymentPage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const [intent, setIntent] = useState<string | undefined>(undefined)
    const [enrollment, setEnrollment] = useState<string | undefined>(undefined)
    const [options, setOptions] = useState<StripeElementsOptions | undefined>(undefined)
    const [cost, setCost] = useState<number | undefined>(undefined)

    const school = useSelector((state: RootState) => state.school)
    const login = useSelector((state: RootState) => state.login)

    const stripePromise = loadStripe(configData.STRIPE_PK)

    useEffect(() => {
        dispatch(pageLoadingSActions.showLoading())

        const transientId = searchParams.get('transientId')
        const enrollmentId = searchParams.get('enrollmentId')

        if (transientId && enrollmentId) {
            setEnrollment(enrollmentId)

            pipe(
                {
                    secret: createIntent(school.id!, transientId, enrollmentId, login.user!.email!),
                    costEnrollments: getEnrollmentsCost(enrollmentId, transientId)
                },
                sequenceS(OBS.Monad)
            ).subscribe(
                ({secret, costEnrollments}) => {
                    setCost(costEnrollments)

                    setIntent(secret)

                    setOptions({
                        clientSecret: secret,
                        appearance: {
                            inputs: "spaced",
                            labels: "floating"
                        },
                    })
                },
                () => navigate('/home'),
                () => dispatch(pageLoadingSActions.hideLoading())
            )
        } else {
            dispatch(notificationActions.error({message: "Parametri obbligatori mancanti."}))
            navigate('/home')
        }

    }, [])


    return (
        <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
            <h5 style={{textAlign: "center", fontSize: "30px", marginBottom: "0px"}}>
                Inserisci i dati della carta per completare il pagamento
            </h5>
            {cost &&
                <h2 style={{textAlign: "center", marginBottom: "30px"}}>
                    Il costo totale dei nuovi tesseramenti è di: {cost}
                </h2>
            }
            {
                options && intent && enrollment ?
                    <Elements stripe={stripePromise} options={options}>
                        <EnrollmentPaymentFormComponent clientSecret={intent}
                                                        enrollmentId={enrollment}></EnrollmentPaymentFormComponent>
                    </Elements>
                    : <div>Caricamento...</div>
            }
        </div>
    )

}